<template>
  <div class="blk_feature">
    <div v-if="name" class="feature_photo"><img :src="imgSrc" alt=""></div>
    <h2 class="feature_title h_deco h_feature pos_r">{{ upperTitle() }}</h2>
    <p class="feature_summary" :class="{vartical: vartical}" v-html="copy"></p>
    <p class="feature_txt" v-html="text"></p>
  </div>
</template>

<script>
// molcules
import PictureFrame from '../molcules/pictureFrame.vue'

// organisms
import FeatureFacilities from './featureFacilities.vue'

export default {
  name: 'Feature',
  components: {
    PictureFrame,
    FeatureFacilities
  },
  props: {
    msg: String,
    name: String,
    vartical: {
      type: Boolean,
      default: false
    },
    title: String,
    copy: String,
    text: String,
    lists: Array
  },
  data () {
    return {
      imgSrc: `/assets/img/about/img_${this.name}.png`
    }
  },
  methods: {
    upperTitle: function(){
      return String(this.title).toUpperCase()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
